// extracted by mini-css-extract-plugin
export default {"MarkedContainer":"MarkedText_MarkedContainer__WbedA"};